import {ExpandMore} from "@mui/icons-material";
import {Accordion, AccordionDetails, AccordionSummary, Grid, TextField} from "@mui/material";
import * as React from "react";
import {useState} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {useRecoilValue} from "recoil";
import {EDITING} from "../../../../service/FinesSecurityRecoil";
import {DatePicker} from "@mui/x-date-pickers";
import {STATUS_IN_PROGRESS} from "../../../../component/Constants";

const EventLocation = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const [isExpanded, setIsExpanded] = useState(false);
    const {register, control, watch}  = useFormContext();
    const editing = useRecoilValue(EDITING);


    return (
        <Accordion defaultExpanded={true}  onChange={(_e,expanded) => {
            setIsExpanded(expanded); 
        }}>
            <AccordionSummary expandIcon={<ExpandMore/>}>
                <Grid item md={6} xs={6}>
                    {t("tabs.eventLocation") }
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container columnSpacing={3} rowSpacing={1}>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                            id="eventCountry"
                            label={t("eventCard.country")}
                            type="text"
                            {...register("eventCountry")}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                            id="eventRegion"
                            label={t("eventCard.region")}
                            type="text"
                            {...register("eventRegion")}
                        />
                    </Grid>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                            id="eventCity"
                            label={t("eventCard.city")}
                            type="text"
                            {...register("eventCity")}
                        />
                    </Grid>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                            id="eventProvince"
                            label={t("eventCard.province")}
                            type="text"
                            {...register("eventProvince")}
                        />
                    </Grid>
                    <Grid item  xs={6}>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                            id="eventAddresss"
                            label={t("eventCard.address")}
                            type="text"
                            {...register("eventAddress")}
                        />
                    </Grid>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                            id="prosecutionNumber"
                            label={t("eventCard.prosecutionNumber")}
                            type="text"
                            {...register("prosecutionNumber")}
                        />
                    </Grid>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                            id="complaintAuthority"
                            label={t("eventCard.complaintAuthority")}
                            type="text"
                            {...register("complaintAuthority")}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"eventDatetime"}
                            render={({field, fieldState}) => (
                                <DatePicker
                                    label={t("eventCard.dateOfEvent")}
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled={!editing}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            disabled={!editing}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}/>
                                    }
                                    inputFormat={"L"}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"complaintDatetime"}
                            render={({field, fieldState}) => (
                                <DatePicker
                                    label={t("eventCard.dateOfComplaint")}
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled={!editing || !!props.theftMisappropriate?.complaintDatetime}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            required={watch("eventStatus.eventStatusCode") === STATUS_IN_PROGRESS}
                                            disabled={!editing || !!props.theftMisappropriate?.complaintDatetime}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}/>
                                    }
                                    inputFormat={"L"}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default EventLocation;